<template lang="pug">
  v-dialog(v-model="show", persistent, max-width="50%")
    v-card
      v-card-title
        v-flex.md8.title Repasses Disponíveis
        v-flex.md4.text-xs-right
          v-btn(flat, @click="show = false;", density="comfortable", icon="", variant="plain")
            v-icon close
      v-card-text.pa-0
        repasses(ref="repasses")
</template>
  
<script>
import repasses from '@/pages/financeiro/repasse/Lista';

export default {
  components: {
    repasses,
  },
  data () {
    return {
      show : false,
      repasses: []
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(repasses){
      const vm = this;
      vm.show = true;
      vm.repasses = _.cloneDeep(repasses);
      _.forEach(vm.repasses, function (o) {
        return o.data_referencia = vm.$dayjs(o.data_referencia).format("MMM YYYY").toUpperCase();
      });
      this.$refs.repasses.setRepasses(vm.repasses);
    },
    close(){
      const vm = this;
      vm.show = false;
    }
  }
}
</script>